// Define the RootState interface which includes the patient slice

import { PatientStore as PatientSlice } from "@/Patient/Stores/PatientStore";

// Define the RootState interface which includes the patient slice
interface RootState {
    patient: PatientSlice;
}

// Function to get the state based on the provided selector
function getState<T>(select: (state: RootState) => T): T {
    // Mock state object with patient store
    const state = {
        patient: patientStore
    };

    // Return the selected part of the state
    return select(state);
}

// Custom hook to use the selector function
function useSelector<T>(select: (state: RootState) => T): T {
    // Use the getState function to get the selected state
    return getState(select);
}

export { getState, useSelector };
